import React from "react";
import { Button, Header, Text } from ".";
import { env } from "src/utils/env";

type ApplyNowProps = {
  onModalLeadFormOpen: () => void;
};

const ApplyNow = (props: ApplyNowProps) => {
  const { onModalLeadFormOpen } = props;

  return (
    <React.Fragment>
      <div className="apply-now">
        <div className="apply-now__container">
          <div className="apply-now__image">
            <img
              src={`${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/66d007e1-3ff2-4033-ad54-9f10899dc450/cash-loan-apply-now.png`}
              alt="Coba Ajukan Sekarang"
            />
          </div>
          <div className="apply-now__body">
            <div className="apply-now__body-text">
              <Header>Coba Ajukan Sekarang</Header>
              <Text>
                Gak perlu menunda, segera raih pembiayaan tanpa agunan melalui
                Home Credit ini.
              </Text>
            </div>
            <div className="apply-now__button">
              <Button onClick={onModalLeadFormOpen}>
                Ajukan Sekarang di Sini
              </Button>
              <Text
                fontSize={["10px", "12px"]}
                lineHeight={["14px", "16px"]}
                letterSpacing={["0.32px", "0.24px"]}
              >
                Jadwal operasional: Senin-Jumat, pukul 09.00-18.00 WIB.
              </Text>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .apply-now {
          background-color: #ffffff;
        }

        .apply-now__container {
          max-width: 1064px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          padding: 0;
        }

        .apply-now__image {
          display: flex;
          padding: 10px 0;
        }

        .apply-now__image img {
          width: 100%;
          height: auto;
        }

        .apply-now__body-text {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 32px 16px 16px;
        }

        .apply-now__button {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 16px;
        }

        .apply-now__button .button {
          height: 36px;
          font-family: Lexend;
          font-size: 12px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: 0.005em;
          text-align: center;
          padding: 6px 8px;
        }

        @media only screen and (min-width: 480px) {
          .apply-now__container {
            flex-direction: row;
            align-items: center;
            gap: 16px;
            padding: 48px;
          }

          .apply-now__image {
            flex: 1;
            padding: 0;
          }

          .apply-now__body-text {
            padding: 0 16px;
          }

          .apply-now__button {
            gap: 4px;
          }

          .apply-now__button .button {
            height: 44px;
            font-family: Lexend;
            font-size: 16px;
            font-weight: 500;
            line-height: 32px;
            letter-spacing: 0.005em;
            text-align: center;
            padding: 6px 24px;
          }

          .apply-now__body {
            flex: 1;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default ApplyNow;
